import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfigBaseComponent } from '../../../models/config-base-component';
import { ConfigWindow } from '../../../models/config-window';
import { EditorAceComponent } from '../../controls/editor-ace/editor-ace.component';

import { ContextMenuComponent } from 'ngx-contextmenu';
import { CdkDragStart, CdkDragMove, CdkDragDrop, moveItemInArray, copyArrayItem, transferArrayItem } from '@angular/cdk/drag-drop';
import { PropertyGridComponent } from '../property-grid/property-grid.component';
import { List } from 'linqts';



@Component({
  selector: 'app-property-grid-controls',
  templateUrl: './property-grid-controls.component.html',
  styleUrls: ['./property-grid-controls.component.css']
})
export class PropertyGridControlsComponent extends PropertyGridComponent implements OnInit {


  public NuevaQueryConfig() {
    this.subControl.ConfigControl.QueryConfig = {
      "Command": "",
      "IsSp": false,
      "Entity": {},
      "WithPagination": false,
      "OutPutParam": false,
    };
  }
  public NuevaConfig() {
    this.subControl.ExportSettings = {};
  }
  public EliminarConfig() {
    this.subControl.ExportSettings = null;
  }

  public OnChangeEntities() {

    if (this.subControl.ConfigControl.Controller) {
      this.subControl.ConfigControl.QueryConfig.CrudAction = "GetByFilterOrderBy";
      this.subControl.ConfigControl.QueryConfig.EntityName = this.subControl.ConfigControl.Controller;
    }
  }
  public OnChangeProcedures() {
    if (this.subControl.ConfigControl.QueryConfig.Command) {
      this.subControl.ConfigControl.QueryConfig.IsSp = true;
      this.subControl.ConfigControl.QueryConfig.CrudAction = "None";
      this.subControl.ConfigControl.QueryConfig.EntityName = undefined;
    }
    else {
      this.subControl.ConfigControl.QueryConfig.IsSp = false;
      this.subControl.ConfigControl.QueryConfig.CrudAction = "GetByFilterOrderBy";
      this.subControl.ConfigControl.QueryConfig.EntityName = this.subControl.ConfigControl.Controller;
    }
  }
  public OnChangeHandlerGidViewParams(event) {

    this.subControl.ConfigControl.Params = event;
    this.UpdateEditor(this.subControl);
  }
  public OnChangeHandlerGidViewParamsQueryConfig(event) {

    this.subControl.ConfigControl.QueryConfig.Entity = event;
    this.UpdateEditor(this.subControl);
  }

  public AddColumn() {
    if (this.subControl) {
      if (!this.subControl.Controls)
        this.subControl.Controls = [];
      if (this.subControl.IsExtendableTable || this.subControl.IsExtendableFileTable) {
        this.subControl.Controls.push(this.utility.GeModelControl("TextBox"));
      }
      else
        this.subControl.Controls.push(this.utility.GetColumnModel());
    }
  }
  public DeleteColumn(event) {
    if (this.subControl && this.subControl.Controls) {
      this.subControl.Controls.splice(event, 1);
    }
  }
  public ChangeWithQueryBuilder(WithQueryBuilder) {
    if (WithQueryBuilder)
      this.subControl.WithFilterControls = true;
  }
  public AddControlFiltro() {

    if (this.subControl) {
      if (!this.subControl.FilterControls)
        this.subControl.FilterControls = [];

      this.subControl.FilterControls.push(this.utility.GeModelControl("TextBox"));

    }
  }
  public DeleteControlFiltro(event) {
    if (this.subControl && this.subControl.FilterControls) {
      this.subControl.FilterControls.splice(event, 1);
    }
  }
  public Update() {
    this.UpdateEditor(this.subControl);
  }
  public UpdateEditor(subControl?: any) {
    this.subControl = subControl;
    if (this.subControl && this.subControl.ControlType !== 'Column') {

      if (this.editorAce)
        this.editorAce.Update(this.subControl.ConfigControl);
      //if (this.propGridConfigControl)
      //this.propGridConfigControl.UpdateEditor(this.subControl);
      /*  if (this.IsControlWithConfigControl()) {
         if (this.editorAceEntity)
           this.editorAceEntity.Update(this.subControl.ConfigControl.QueryConfig.Entity);
         if (this.editorAceParams)
           this.editorAceParams.Update(this.subControl.ConfigControl.Params);
       } */
    }
  }


  public OnChangeHandlerButtons(event) {
    this.subControl.Controls = event;
    //this.UpdateEditor(this.subControl);
  }



  public get ParentName(): string {

    if (this.subControl && this.subControl.ConfigControl && this.subControl.ConfigControl.ConfigParent)
      return this.subControl.ConfigControl.ConfigParent.ParentName;
    else
      return '';
  }
  public set ParentName(value: string) {

    if (this.subControl) {
      if (!this.subControl.ConfigControl) {
        if (value)
          this.subControl.ConfigControl = { ConfigParent: { ParentName: value } };
        else
          this.subControl.ConfigControl = { ConfigParent: null };
      }
      else if (!this.subControl.ConfigControl.ConfigParent) {
        if (value)
          this.subControl.ConfigControl.ConfigParent = { ParentName: value };
        else
          this.subControl.ConfigControl.ConfigParent = null;
      }
      else if (this.subControl.ConfigControl.ConfigParent) {
        if (value)
          this.subControl.ConfigControl.ConfigParent = { ParentName: value };
        else
          this.subControl.ConfigControl.ConfigParent = null;
      }
    }
  }
  public OnChangeParent(event) {

    debugger;

    let controles = new List<any>(this.resultParentControls);
    // if(event)
    //const child =controles.FirstOrDefault(x=> { x.ConfigControl.ConfigParent && })
  }


  verProperty(control, index): any {
    let config: ConfigWindow = new ConfigWindow();
    config.classWindow = 'info';
    config.titleWindow = "Propiedades";
    config.returnInstance = false;
    config.modal = false;
    config.width = 600;
    config.height = 600;
    config.viewOk = false;
    config.cancel = 'Cerrar';
    let windowModel: any = {
      subControl: control,
      subControlIndex: -1
    };

    this.utility.OpenWindow('PropertyGridControlsComponent',
      config, windowModel).then(dataResult => {
        // console.log(dataResult);
        debugger;
        dataResult.onClosePromise.then(dataResultOnClose => {
          // console.log(dataResultOnClose);
          debugger;

        });

      })

  }
}



